import { useDispatch } from 'react-redux';
import {
  SaveMailingAddressForm,
  SelectMailingAddress,
} from '../redux/actions/mailingAddressActions';
import {
  ChangeScreen,
  DisableSpinner,
  CancelSubmit,
} from '../redux/actions/screenActions';
import useUserUUID from './useUserUUID';
import ApiCall from '../redux/sagas/ApiCall';
import { RejectApiStatus } from '../redux/actions/apiActions';
import CaseTransformer from '../helpers/CaseTransformer';

const useMailingActions = () => {
  const dispatch = useDispatch();
  const uuid = useUserUUID();

  const selectMailingAddress = (useHomeAddress) => dispatch(SelectMailingAddress(useHomeAddress));

  const saveMailingAddress = (values) => {
    dispatch(SaveMailingAddressForm(values));
    try {
      const body = CaseTransformer.keysToSnake(values);
      ApiCall('/application/mailingStep', { ...body, uuid }, true);

      dispatch(
        ChangeScreen({
          link: '/declaration',
          form: 'declaration',
        }),
      );
    } catch (e) {
      dispatch(
        RejectApiStatus({
          responseData: e.response.data,
        }),
      );

      dispatch(DisableSpinner());
      dispatch(CancelSubmit());
    }
  };

  return { selectMailingAddress, saveMailingAddress };
};

export default useMailingActions;
